import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TechRoleService } from "../../../services/TechRoleService";
import ModalContainer from "../../../containers/Modal/ModalContainer";

export default function CreateOrEdit({
  onClose,
  techRoleId,
  isOpen,
  techAreas
}) {
  const [errors, setErrors] = useState({});
  const [techRole, setTechRole] = useState({});
  let { t } = useTranslation();
  useEffect(() => {
    if (techRoleId)
      TechRoleService.getById(techRoleId).then((data) => {
        setTechRole(data);
      });
  }, [techRoleId]);
  function onChange({ target }) {
    setTechRole({ ...techRole, [target.name]: target.value });
  }
  function createOrUpdate() {
    if (validate()) return;
    TechRoleService.createOrUpdate(techRole).then((data) => {
      setTechRole({});

      onClose();
    });
  }
  function validate() {
    let errors = {};
    if (!techRole.description) errors.description = t("Required");
    setErrors(errors);
    return Object.keys(errors).length > 0;
  }
  return (
    <ModalContainer
      modalTitle={t("Create or Edit Tech Role")}
      onClose={onclose}
      submitButtonAction={createOrUpdate}
      submitButtonTitle={t("Save")}
      cancelButtonTitle={t("Cancel")}
      cancelButtonAction={onClose}
      submitButtonType="button"
      isOpen={isOpen}
    >
      <div className="form-group">
        <div className="label-wrapper">
          <label className="label">{t("Name")}</label>
          <div className="error-msg">{errors.description}</div>
        </div>
        <input
          onChange={onChange}
          className="form-control"
          name="description"
          value={techRole.description || ""}
        />
      </div>
      <div className="form-group">
        <div className="label-wrapper">
          <label className="label">{t("Tech Area")}</label>
          <div className="error-msg">{errors.techAreaId}</div>
        </div>
        <select
          className="form-control"
          required
          title={t("Selecione um item da lista.")}
          name="techAreaId"
          onChange={onChange}
          value={techRole.techAreaId || ""}
        >
          <option key={0} value="" selected>
            {t("Tech Area...")}
          </option>
          {techAreas.map((techArea) => (
            <option key={techArea.id} value={techArea.id}>
              {t(techArea.description)}
            </option>
          ))}
        </select>
      </div>
    </ModalContainer>
  );
}
